import Phaser from "phaser"

import { cScene } from "../cScene";
import { ScreenItem } from "../dataTypes";
import { ModuleCollection, Base } from "../cGameObjects/modules";

export class Clouds extends Phaser.GameObjects.Container {

  public readonly isContainer: boolean = true;

  public modules: ModuleCollection;
  private _data: ScreenItem
  private sp: number = 2;

  constructor(sc:cScene, data: ScreenItem){
    super(sc,0,0);
    this._data = data;
    this.modules = Base.initModules(this,data);
    sc.events.on('render',()=>{
      this.moveClouds();
    });

    this.appendCloud(0)
    this.appendCloud(400)
    this.appendCloud(800)
    this.appendCloud(1600)

    if (sc.debugMode){
      let _debugRect = new Phaser.GameObjects.Graphics(sc) //  this.ref.add.graphics();
      var r:any = this.modules.layout.getOfs( '' )
      if (!r) r={x:100,y:100}
      _debugRect.lineStyle(1, 0xff9900, 0.8);
      _debugRect.x = 0;
      _debugRect.y = 0;      
      _debugRect.fillStyle(0xff9900,0.2)
      _debugRect.fillRect(0,0,1920,200)
      _debugRect.strokeRect(0, 0, 1920, 200);
      this.add(_debugRect)
    }    

  }


  moveClouds(){
    var items = this.getAll();
    items.forEach( (el: any)=>{
      el.x -= this.sp;
      if (el.x < -480){
        el.destroy();
        this.appendCloud(2200)
      }
    })
  }

  getOfs(){
    var res =  Math.floor( Math.random() * 6 ) + 1;
    return res
  }

  appendCloud(xx:number){
    var cloudName:string = 'wolke_' + this.getOfs() + '.png';
    var cc = new Phaser.GameObjects.Sprite(this.scene,xx, Math.random() * 200, 'wolken',cloudName);
    cc.scale = 2
    this.add(cc);
  }


  public set speed(v:number){
    this.sp = v / 100
  }

  public get speed(){
    return this.sp * 100
  }

}